import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const SvgI280Placeholder = props => {
  return (
    <SvgIcon {...props}>
      <path
        opacity="0.2"
        d="M79 61.0001C79 57.6864 81.6863 55.0001 85 55.0001H176.599C178.14 55.0001 179.622 55.5934 180.738 56.6569L209.14 83.7271C210.328 84.8594 211 86.429 211 88.0703V229C211 232.314 208.314 235 205 235H85C81.6863 235 79 232.314 79 229V61.0001Z"
        fill="#75BFBB"
        stroke="#75BFBB"
        strokeWidth="4"
      />
      <path
        d="M72 54C72 50.6863 74.6863 48 78 48H169.599C171.14 48 172.622 48.5933 173.738 49.6568L202.14 76.727C203.328 77.8593 204 79.4289 204 81.0702V222C204 225.314 201.314 228 198 228H78C74.6863 228 72 225.314 72 222V54Z"
        fill="white"
      />
      <rect x="88" y="94" width="44" height="10" rx="5" fill="#84CFCB" />
      <rect
        opacity="0.4"
        x="88"
        y="124"
        width="100"
        height="10"
        rx="5"
        fill="#84CFCB"
      />
      <rect
        opacity="0.4"
        x="88"
        y="144"
        width="100"
        height="10"
        rx="5"
        fill="#84CFCB"
      />
      <rect
        opacity="0.4"
        x="88"
        y="164"
        width="100"
        height="10"
        rx="5"
        fill="#84CFCB"
      />
      <rect
        opacity="0.4"
        x="88"
        y="184"
        width="50"
        height="10"
        rx="5"
        fill="#84CFCB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50 31C48.8954 31 48 31.8954 48 33V39H42C40.8954 39 40 39.8954 40 41C40 42.1046 40.8954 43 42 43H48V49C48 50.1046 48.8954 51 50 51C51.1046 51 52 50.1046 52 49V43H58C59.1046 43 60 42.1046 60 41C60 39.8954 59.1046 39 58 39H52V33C52 31.8954 51.1046 31 50 31Z"
        fill="#84CFCB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M241 194C239.895 194 239 194.896 239 196V202H233C231.895 202 231 202.896 231 204C231 205.105 231.895 206 233 206H239V212C239 213.105 239.895 214 241 214C242.105 214 243 213.105 243 212V206H249C250.105 206 251 205.105 251 204C251 202.896 250.105 202 249 202H243V196C243 194.896 242.105 194 241 194Z"
        fill="#84CFCB"
      />
      <path
        opacity="0.6"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M228.659 48.5883C227.592 48.8742 226.959 49.9709 227.245 51.0378L228.798 56.8334L223.002 58.3863C221.935 58.6722 221.302 59.7688 221.588 60.8358C221.874 61.9027 222.971 62.5359 224.038 62.25L229.833 60.6971L231.386 66.4926C231.672 67.5596 232.769 68.1927 233.836 67.9068C234.903 67.621 235.536 66.5243 235.25 65.4574L233.697 59.6618L239.492 58.1089C240.559 57.823 241.193 56.7263 240.907 55.6594C240.621 54.5925 239.524 53.9593 238.457 54.2452L232.662 55.7981L231.109 50.0025C230.823 48.9356 229.726 48.3024 228.659 48.5883Z"
        fill="#84CFCB"
      />
      <path
        opacity="0.6"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.6593 218.588C34.5923 218.874 33.9592 219.971 34.245 221.038L35.798 226.833L30.0024 228.386C28.9355 228.672 28.3023 229.769 28.5882 230.836C28.8741 231.902 29.9707 232.536 31.0377 232.25L36.8332 230.697L38.3861 236.492C38.672 237.559 39.7687 238.192 40.8356 237.907C41.9026 237.621 42.5357 236.524 42.2499 235.457L40.6969 229.662L46.4925 228.109C47.5594 227.823 48.1926 226.726 47.9067 225.659C47.6208 224.592 46.5241 223.959 45.4572 224.245L39.6617 225.798L38.1087 220.002C37.8229 218.935 36.7262 218.302 35.6593 218.588Z"
        fill="#84CFCB"
      />
      <circle
        opacity="0.3"
        cx="145"
        cy="22"
        r="6"
        stroke="#84CFCB"
        strokeWidth="4"
      />
      <circle
        opacity="0.3"
        cx="104"
        cy="260"
        r="6"
        stroke="#84CFCB"
        strokeWidth="4"
      />
      <circle
        opacity="0.3"
        cx="55"
        cy="103"
        r="5"
        stroke="#84CFCB"
        strokeWidth="4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74 54C74 51.7909 75.7909 50 78 50H169.599C169.733 50 169.867 50.0068 170 50.0202V73C170 77.4183 173.582 81 178 81H201.999C202 81.0234 202 81.0467 202 81.0702V222C202 224.209 200.209 226 198 226H78C75.7909 226 74 224.209 74 222V54ZM199.527 77L174 52.6692V73C174 75.2091 175.791 77 178 77H199.527ZM78 46C73.5817 46 70 49.5817 70 54V222C70 226.418 73.5817 230 78 230H198C202.418 230 206 226.418 206 222V81.0702C206 78.8818 205.104 76.789 203.52 75.2792L175.118 48.2091C173.63 46.791 171.654 46 169.599 46H78Z"
        fill="#75BFBB"
      />
    </SvgIcon>
  );
};

export default SvgI280Placeholder;
